module.exports = "/build/web/svg/social/small/whatsapp.1e6bbc41a24a195f4ee9e757478cf7de.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/social/small/whatsapp.svg
// module id = 197
// module chunks = 24